module.exports = __webpack_public_path__ + "media/images/puzzle/puzzle_107-ec953f2618555bec35801affd37bf3ef.png";